import React from 'react'
import PropTypes from 'prop-types'
import { Input } from '@babylon/ui'
import Address from '@/components/GpAddressWrapper'
import Form from '@/components/Form'

const arrayFields = ({ clinicalUserInformation: data, regionId }) => [
  {
    rowFields: [
      {
        component: Input,
        type: 'text',
        name: 'gp_name',
        label: 'GP name',
        required: true,
        defaultValue: data.gp_name || '',
      },
    ],
  },
  {
    rowFields: [
      {
        component: Input,
        type: 'text',
        name: 'gp_surgery_name',
        label: 'Surgery name',
        required: false,
        defaultValue: data.gp_surgery_name || '',
      },
    ],
  },
  {
    rowFields: [
      {
        component: Input,
        type: 'tel',
        name: 'gp_surgery_phone_number',
        label: 'Surgery phone number',
        defaultValue: data.gp_surgery_phone_number || '',
      },
    ],
  },
  {
    title: 'Surgery address',
    rowFields: [
      {
        component: Address,
        name: 'address',
        defaultValues: {
          gp_address_post_code: data.gp_address_post_code || '',
          gp_address_first_line: data.gp_address_first_line || '',
          gp_address_second_line: data.gp_address_second_line || '',
          gp_address_third_line: data.gp_address_third_line || '',
        },
        label: 'Surgery address',
        regionId,
        isGpAddress: true,
      },
    ],
  },
]

const formOptions = {
  submitBtnText: 'Save',
}

const GpForm = ({
  isUpdateDisabled,
  onSubmit,
  onCancel,
  clinicalUserInformation,
  regionId,
  options,
}) => (
  <Form
    disabled={isUpdateDisabled}
    onSubmit={onSubmit}
    onCancel={onCancel}
    fields={arrayFields({ clinicalUserInformation, regionId })}
    options={options || formOptions}
    operationName="updateGP"
    checkPristine
  />
)

GpForm.defaultProps = {
  fields: null,
  errors: null,
  clinicalUserInformation: {},
  options: null,
  onCancel: null,
}

GpForm.propTypes = {
  clinicalUserInformation: PropTypes.shape({}).isRequired,
  regionId: PropTypes.string.isRequired,
  options: PropTypes.shape({
    submitBtnText: PropTypes.string,
    cancelBtnText: PropTypes.string,
  }),
}

export default GpForm
